export class HistoricoContatoSignature {
  id: string = null;
  clienteId: string = null;
  resumo: string = null;

  constructor(values: Partial<HistoricoContatoSignature> = { }) {

  Object.assign(this, values)
  }
}
